/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  'use strict';
 
  var REQUIRED = ['ギフトボックス', 'ギフトバッグ', '風呂敷'];
  var TARGET   = '無料ギフトカードを選ぶ';
  var MESSAGE  = 'ギフトラッピングをお選びいただくと選択できます。';
 
  var ATTR = 'data-gog-msg';   // この属性が付いている間がロック状態
  var OPEN = 'is-gog-open';    // タッチ端末向けツールチップ表示
 
  var busy = false;
  var timer = null;

  // GOP の更新（2026-10）でラッピングのチェックボックスがなくなったため、
  // ラッピングを選んでいるかはカートの中身（GOP が追加したラッピング）で判定する
  var wrappingInCart = false;
  var cartReady = false;
  var cartLoading = false;
  var cartPending = false;
  var cartTimer = null;

  function refreshCart() {
    if (!widget(TARGET)) return;
    if (cartLoading) { cartPending = true; return; }
    cartLoading = true;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        wrappingInCart = cart.items.some(function (item) {
          var props = item.properties || {};
          return REQUIRED.indexOf(props._OptionLabel) !== -1;
        });
        cartReady = true;
        sync();
      })
      .catch(function () {})
      .then(function () {
        cartLoading = false;
        if (cartPending) { cartPending = false; scheduleCart(); }
      });
  }

  function scheduleCart() {
    if (cartTimer) return;
    cartTimer = setTimeout(function () { cartTimer = null; refreshCart(); }, 300);
  }
 
  function widget(label) {
    return document.querySelector('[data-dw-widget-label="' + label + '"]');
  }
 
  function checkbox(el) {
    return el && el.querySelector('label.gop-checkbox__root > input[type="checkbox"]');
  }
 
  function sync() {
    if (busy || !cartReady) return;
 
    var target = widget(TARGET);
    var cb = checkbox(target);
    if (!cb) return;
 
    var unlocked = wrappingInCart || REQUIRED.some(function (label) {
      var c = checkbox(widget(label));
      return !!c && c.checked;
    });
 
    if (unlocked) {
      cb.disabled = false;
      target.removeAttribute(ATTR);
      return;
    }
 
    // disabled にする前に、アプリのハンドラを通してチェックを外す
    if (cb.checked) {
      busy = true;
      try { cb.click(); } finally { busy = false; }
    }
    cb.disabled = true;
    if (target.getAttribute(ATTR) !== MESSAGE) target.setAttribute(ATTR, MESSAGE);
  }
 
  // requestAnimationFrame はバックグラウンドタブで止まり、
  // 再開しないままフラグが残るので使わない
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; sync(); }, 30);
  }
 
  // タッチ端末では :hover が効かないのでタップで一時表示
  function showTip(e) {
    var el = e.target.closest && e.target.closest('[' + ATTR + ']');
    if (!el) return;
    el.classList.add(OPEN);
    clearTimeout(el._gogTimer);
    el._gogTimer = setTimeout(function () { el.classList.remove(OPEN); }, 3000);
  }
 
  function init() {
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', showTip);
    document.addEventListener('visibilitychange', schedule);
 
    // アプリ／テーマによる再描画（カートセクションの再取得など）に追従
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(scheduleCart).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:updated', scheduleCart);
    refreshCart();
    setInterval(schedule, 500);
 
    sync();
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// assets/custom.js に追加
(function () {
  var headerComponent = document.querySelector('header-component[data-header-wrapper]');
  if (!headerComponent) return;

  var repaintTarget = document.querySelector('.header-sections') || headerComponent.parentElement;

  function forceRepaint(el) {
    if (!el) return;
    el.style.transform = 'translateZ(0)';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.transform = '';
      });
    });
  }

  // position: fixed が解除された(js__header__stuck が外れた)瞬間を検知
  var wasStuck = headerComponent.classList.contains('js__header__stuck');
  var observer = new MutationObserver(function () {
    var isStuck = headerComponent.classList.contains('js__header__stuck');
    if (wasStuck && !isStuck) {
      forceRepaint(repaintTarget);
    }
    wasStuck = isStuck;
  });
  observer.observe(headerComponent, { attributes: true, attributeFilter: ['class'] });
})();